
export default function CaseListSection() {
  const cases = [
    {
      id: 'NO.901',
      title: '飲食店チェーン',
      industry: '飲食業',
      location: '東京都',
      price: '1億8,000万円',
      date: '2024年11月',
      buyer: '外食産業大手企業',
      description: '都内に5店舗を展開する人気イタリアンレストラン。安定した収益基盤と優秀なスタッフ、確立されたブランド力が評価されました。'
    },
    {
      id: 'NO.902',
      title: 'ITシステム開発会社',
      industry: 'IT・ソフトウェア',
      location: '神奈川県',
      price: '1億2,500万円',
      date: '2024年10月',
      buyer: 'IT企業',
      description: '大手企業との取引実績が豊富なシステム開発会社。技術力の高いエンジニアチームと安定した受注が魅力でした。'
    },
    {
      id: 'NO.903',
      title: '美容室チェーン',
      industry: '美容・サロン',
      location: '大阪府',
      price: '9,800万円',
      date: '2024年10月',
      buyer: '美容業界企業',
      description: '大阪市内に3店舗を展開する人気美容室。固定客が多く、スタイリストの技術力も高い優良案件でした。'
    },
    {
      id: 'NO.904',
      title: 'ECサイト運営会社',
      industry: 'EC・通販',
      location: '東京都',
      price: '8,500万円',
      date: '2024年9月',
      buyer: 'EC事業者',
      description: 'ファッション系ECサイトを運営。独自の顧客基盤とマーケティングノウハウが高く評価されました。'
    },
    {
      id: 'NO.905',
      title: '介護施設運営会社',
      industry: '医療・介護',
      location: '愛知県',
      price: '7,200万円',
      date: '2024年9月',
      buyer: '医療法人',
      description: 'デイサービスと訪問介護を展開。地域密着型で評判が良く、安定した経営基盤を持つ施設でした。'
    },
    {
      id: 'NO.906',
      title: '学習塾チェーン',
      industry: '教育・学習支援',
      location: '埼玉県',
      price: '6,800万円',
      date: '2024年8月',
      buyer: '教育関連企業',
      description: '県内に4教室を展開する進学塾。高い合格実績と地域での信頼が評価ポイントでした。'
    },
    {
      id: 'NO.907',
      title: '運送会社',
      industry: '運輸・物流',
      location: '千葉県',
      price: '6,500万円',
      date: '2024年8月',
      buyer: '物流企業',
      description: '中型トラック10台を保有する運送会社。大手企業との長期契約があり、安定収益が魅力でした。'
    },
    {
      id: 'NO.908',
      title: 'フィットネスジム',
      industry: 'スポーツ・フィットネス',
      location: '福岡県',
      price: '5,900万円',
      date: '2024年7月',
      buyer: 'フィットネス事業者',
      description: '24時間営業のフィットネスジム2店舗。会員数が安定しており、設備も充実していました。'
    },
    {
      id: 'NO.909',
      title: '製造業（金属加工）',
      industry: '製造業',
      location: '静岡県',
      price: '5,200万円',
      date: '2024年7月',
      buyer: '製造業企業',
      description: '精密金属加工を手がける製造業。高い技術力と大手メーカーとの取引実績が評価されました。'
    },
    {
      id: 'NO.910',
      title: 'Webマーケティング会社',
      industry: 'マーケティング',
      location: '東京都',
      price: '4,800万円',
      date: '2024年6月',
      buyer: '広告代理店',
      description: 'SEO・SNS運用を中心としたWebマーケティング会社。クライアント基盤が強固で継続率も高い案件でした。'
    },
    {
      id: 'NO.911',
      title: '不動産管理会社',
      industry: '不動産',
      location: '神奈川県',
      price: '4,200万円',
      date: '2024年6月',
      buyer: '不動産企業',
      description: 'マンション・アパート管理を中心とした不動産管理会社。管理戸数300戸超で安定収益を実現していました。'
    },
    {
      id: 'NO.912',
      title: 'カフェチェーン',
      industry: '飲食業',
      location: '京都府',
      price: '3,800万円',
      date: '2024年5月',
      buyer: '飲食事業者',
      description: '京都市内に2店舗を展開するおしゃれなカフェ。観光客と地元客の両方から支持される人気店でした。'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">成約事例一覧</h2>
          <p className="text-lg text-gray-600">様々な業種での成約実績をご紹介します</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {cases.map((caseItem) => (
            <div key={caseItem.id} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <div className="bg-gradient-to-r from-teal-500 to-blue-500 px-6 py-4">
                <div className="flex items-center justify-between">
                  <span className="text-white font-bold text-lg">{caseItem.id}</span>
                  <span className="bg-white/20 text-white px-3 py-1 rounded-full text-sm">
                    {caseItem.date}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{caseItem.title}</h3>
                
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm font-medium">
                    {caseItem.industry}
                  </span>
                  <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
                    {caseItem.location}
                  </span>
                </div>

                <div className="mb-4">
                  <div className="flex items-baseline mb-2">
                    <span className="text-sm text-gray-600 mr-2">成約価格：</span>
                    <span className="text-3xl font-bold text-teal-600">{caseItem.price}</span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-sm text-gray-600 mr-2">買手：</span>
                    <span className="text-gray-800 font-medium">{caseItem.buyer}</span>
                  </div>
                </div>

                <p className="text-gray-600 leading-relaxed">{caseItem.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
